import { getResource, sendForSuccess } from "../api/http";

export function getBroadcast(broadcast_id) {
  return getResource(`/api/broadcast/get-broadcast/${broadcast_id}`, {
    select: (data) => (data.data ? data.data : []),
    fallback: [],
  });
}

export function getBroadcastList() {
  return getResource("/api/broadcast/get-all-broadcast", {
    select: (data) => data.data,
  });
}

export function sendBroadcast(obj) {
  return sendForSuccess("post", "/api/broadcast/add-send-broadcast", obj);
}
